import localStorageEx from 'bundles/common/utils/localStorageEx';

export type SavedSurveyResponse = {
  // Full id the server returned, including the survey prefix (`<surveyId>~<surveyResponseId>`).
  responseId: string;
  // The section to submit next.
  sectionId: string;
  surveyVariant: string;
  answers: Record<string, string>;
};

const getStorageKey = (productId: string) => `eoi.multiStepResponse.${productId}`;

const isSavedSurveyResponse = (value: unknown): value is SavedSurveyResponse => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const { responseId, sectionId, surveyVariant, answers } = value as Partial<SavedSurveyResponse>;
  return (
    typeof responseId === 'string' &&
    typeof sectionId === 'string' &&
    typeof surveyVariant === 'string' &&
    typeof answers === 'object' &&
    answers !== null
  );
};

// Returns nothing when there is no entry, or when it was saved for a different survey variant.
export const readSavedSurveyResponse = (productId: string, surveyVariant: string): SavedSurveyResponse | undefined => {
  const saved = localStorageEx.getItemValidated<SavedSurveyResponse | undefined>(
    getStorageKey(productId),
    (value): value is SavedSurveyResponse | undefined => value === undefined || isSavedSurveyResponse(value),
    undefined
  );
  return saved?.surveyVariant === surveyVariant ? saved : undefined;
};

export const writeSavedSurveyResponse = (productId: string, saved: SavedSurveyResponse) => {
  localStorageEx.setItem(getStorageKey(productId), saved, JSON.stringify);
};

export const clearSavedSurveyResponse = (productId: string) => {
  localStorageEx.removeItem(getStorageKey(productId));
};
